import React from 'react'
import CustomizedSwiper from '../../../../basic/CustomizedSwiper'
import Image from '../../../../basic/image'
import Checked from '../../../../static/checked.svg'
import Protected from '../../../../static/protected.svg'
import Settings from '../../../../static/settings.svg'
import Text from '../../../../text'
import styled from 'styled-components'
import TranslateText from 'src/text/modal';

const BoxContainer = styled.div`
  margin-top: 40px;

  ul {
    text-align: left;
  }
`

function Mobile({name, description, img, box, settingsText, protectedText, checkedText}) {
  return (
    <div
      style={{
        textAlign: 'center',
      }}
    >
      <p style={{fontSize: 24, fontWeight: 800, marginTop: 40}}>
        <TranslateText place="bottom" id={name} useTextImmitation={24} />
      </p>
      <p style={{marginTop: 40}}>{description}</p>
      <Image
        src={img}
        className="cover-image"
        style={{
          maxWidth: '90%',
          maxHeight: 250,
        }}
      />

      <BoxContainer>
        <TranslateText place="bottom" id={box} useHtml controls={['bold', 'ul']} />
      </BoxContainer>
      
      <CustomizedSwiper
        list={[
          <div
            style={{
              display: 'inline-block',
              flexGrow: 1,
              padding: 15,
              border: '1px solid rgb(235, 235, 235)',
            }}
          >
            <Image
              src={Settings}
            />
            <TranslateText place="bottom" id={settingsText}/>
          </div>,
          <div
            style={{
              display: 'inline-block',
              flexGrow: 1,
              padding: 15,
              border: '1px solid rgb(235, 235, 235)',
            }}
          >
            <Image
              src={Protected}
            />
            <TranslateText place="bottom" id={protectedText}/>
          </div>,
          <div
            style={{
              display: 'inline-block',
              flexGrow: 1,
              padding: 15,
              border: '1px solid rgb(235, 235, 235)',
            }}
          >
            <Image
              src={Checked}
            />
            <TranslateText place="bottom" id={checkedText}/>
          </div>
        ]}
      />
    </div>
  )
}

export default Mobile


// WEBPACK FOOTER //
// ./src/finwhale/common/category/header/Mobile.js